import React, { useState, useEffect, useRef } from 'react';
import emailjs from 'emailjs-com'; // Importar emailjs
import styles from './FAQ.module.css';
import { FaRegQuestionCircle } from "react-icons/fa";

const FAQ = () => {
  const [expanded, setExpanded] = useState({});
  const [formData, setFormData] = useState({ email: '', celular: '', mensaje: '' });
  const questionRefs = useRef([]); // Referencias a las preguntas

  const questions = [
    { q: '¿Qué tipo de empresas pueden beneficiarse de Relatividad IA y cómo mejorará su eficiencia?', a: 'Las soluciones de Relatividad IA están diseñadas para cualquier empresa que busque mejorar su eficiencia operativa, analítica de datos, atención al cliente o cualquier proceso que requiera el uso de inteligencia artificial avanzada o modelos de aprendizaje de máquinas. La inteligencia artificial es tan poderosa y versátil que puede marcar una diferencia en la productividad de cualquier equipo dentro de una empresa, desde el marketing, finanzas, recursos humanos, manejo y análisis de datos, atención al cliente y más.  Cualquier organización con filosofía de innovación y que tenga claro el impacto de la IA a futuro puede beneficiarse. Si has visualizado una solución particular para tu empresa con IA, nosotros te podemos ayudar a materializarla.' },
    { q: '¿Cuáles son los modelos de IA más avanzados que se utilizan en los productos de Relatividad IA?', a: 'Utilizamos los modelos más poderosos del mundo desde todos los modelos de OpenAI, Google, Anthropic, etc. Nos adaptamos al presupuesto y necesidades de nuestros clientes. Además, nuestras soluciones pueden incorporar visión por computadora, generación de imágenes y reconocimiento de voz, lo que permite a la IA analizar imágenes, sonidos  y mejorar su comprensión del entorno. Dependiendo de las necesidades del cliente, ofrecemos un modelo mixto que utiliza las opciones más adecuadas según la complejidad de la tarea.' },
    { q: '¿Cómo se personalizan los productos de Relatividad IA para cada cliente?', a: 'En Relatividad IA, ofrecemos soluciones totalmente personalizables para adaptarnos a las necesidades únicas de cada cliente. Si tu empresa requiere características adicionales o ajustes específicos, trabajaremos estrechamente contigo para crear tu Inteligencia Artificial. Desde la creación del software, elección de los modelos de IA utilizados, hasta la integración en tus operaciones diarias con un diseño único, nos aseguramos de que el producto final cumpla con todos los requisitos en funcionalidad y estética. Lo que obtienes es una Inteligencia Artificial única y exclusiva, hecha cien por ciento a la medida de tu empresa.' },
    { q: '¿Relatividad IA ofrece capacitaciones para el uso e implementación de sus soluciones?', a: 'Sí, Relatividad IA ofrece capacitaciones personalizadas para garantizar que las empresas puedan aprovechar al máximo nuestras soluciones de inteligencia artificial. Estas capacitaciones están diseñadas tanto para usuarios finales como para equipos técnicos. Cubrimos desde el uso básico de las herramientas hasta la optimización de procesos utilizando IA, asegurando una integración efectiva en las operaciones diarias. Las capacitaciones se adaptan al nivel de conocimiento y roles dentro de la empresa para asegurar que todo el equipo pueda utilizar las soluciones de manera eficiente.' },
    { q: '¿Cuánto tiempo toma implementar una solución de IA en mi empresa?', a: 'El tiempo de implementación depende de la complejidad del proyecto y de la personalización requerida. Generalmente, una implementación básica puede completarse en pocas semanas, mientras que soluciones más complejas pueden tardar algunos meses. Al tener optimizados nuestros procesos internos con Inteligencia Artificial, podemos ofrecer soluciones en una fracción del tiempo en que lo haría una empresa de desarrollo tradicional.' },
    { q: '¿Qué opciones de precios tienen las licencias de los modelos de IA?', a: 'Ofrecemos diferentes opciones de precios para nuestras licencias, que dependen del modelo de IA y las funcionalidades requeridas. Dependiendo del modelo de Inteligencia Artificial que mejor se adapte a tu solución, de si requieres modelos de visión o analítica de datos, el costo variará. Puedes agendar un demo con nosotros para conversar específicamente de tu caso.' },
    { q: '¿Cómo protege Relatividad IA la privacidad y seguridad de los datos de los clientes?', a: 'La seguridad y privacidad de los datos son prioridades en Relatividad IA. Implementamos protocolos avanzados de cifrado y autenticación para proteger la información de nuestros clientes. Además, cumplimos con las normativas internacionales de protección de datos para garantizar que toda la información esté segura.' },
    { q: '¿Se ofrece soporte técnico a las soluciones de IA para adaptarlas a las necesidades del cliente?', a: 'En Relatividad IA, nuestras soluciones de IA se adaptan a las necesidades específicas de cada cliente. Trabajamos estrechamente con las empresas para entender su cultura, misión y objetivos, de modo que nuestras soluciones reflejen la identidad única de cada cliente. Además, implementamos un proceso de mejora continua que incluye reuniones periódicas con los clientes para evaluar el rendimiento de las soluciones y realizar ajustes según sea necesario. Esto asegura que nuestras soluciones evolucionen junto con las necesidades cambiantes del negocio. También ofrecemos soporte técnico continuo, que abarca desde la resolución de problemas técnicos hasta la actualización de funcionalidades y modelos de IA, garantizando que tu organización siempre esté a la vanguardia tecnológica.' },
    { q: '¿Puedo integrar las soluciones de Relatividad IA con el software existente en mi empresa?', a: 'Sí, nuestras soluciones están diseñadas para ser altamente compatibles y flexibles. Podemos integrarlas con el software y las plataformas que ya utiliza tu organización.' },
    { q: '¿Cuáles son los requisitos mínimos para que mi empresa implemente las soluciones de IA y empiece a trabajar con Relatividad IA?', a: 'Para implementar las soluciones de Inteligencia Artificial, se necesita tener un presupuesto significativo dependiendo de la complejidad del producto. Por lo general a partir de un presupuesto de USD 2.000 se puede implementar una IA personalizada en tu organización. Para soluciones más complejas y personalizadas recomendamos un presupuesto de al menos USD 5.000. No es necesario contar con servidores ya que relatividad IA puede conectar tus soluciones con servidores en la nube de los mejores proveedores de estos servicios a nivel mundial.' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const triggerBottom = window.innerHeight / 5 * 4;
      questionRefs.current.forEach((box, idx) => {
        const boxTop = box.getBoundingClientRect().top;
        if (boxTop < triggerBottom) {
          box.classList.add(styles.show);
        } else {
          box.classList.remove(styles.show);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleQuestion = (index) => {
    setExpanded(prev => ({ ...prev, [index]: !prev[index] }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.nombre && formData.email && formData.celular && formData.mensaje) {
      // Usa EmailJS para enviar los datos
      const templateParams = {
        from_name: formData.nombre,     // El nombre del remitente
        email: formData.email,      // El nombre o email del remitente
        message: formData.mensaje,      // El mensaje del remitente
        reply_to: formData.email,       // El correo al cual responder
        celular: formData.celular       // El número de teléfono del remitente
      };
      emailjs.send('service_9lm7req', 'template_156zden', templateParams, 'smutuNGf5OupOJHLZ')
        .then((result) => {
          alert('Mensaje enviado con éxito');
        }, (error) => {
          alert('Error al enviar el mensaje, por favor inténtalo de nuevo');
        });
      /*Agregar que se borren los datos de los campos al enviar con exito*/
      setFormData({ nombre: '', email: '', celular: '', mensaje: '' }); // Limpiar el formulario
    } else {
      alert('Por favor, complete todos los campos.');
    }
  };

  /*const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.email && formData.celular && formData.mensaje) {
      try {
        const response = await fetch('http://localhost:8000/enviar-mensaje', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
  
        if (response.ok) {
          alert('Mensaje enviado con éxito');
          setFormData({ email: '', celular: '', mensaje: '' }); // Limpiar el formulario
        } else {
          alert('Error al enviar el mensaje, por favor inténtalo de nuevo');
        }
      } catch (error) {
        alert('Error en la conexión, por favor inténtalo de nuevo');
      }
    } else {
      alert('Por favor, complete todos los campos.');
    }
  };*/

  // No permitir el scroll horizontal, bloquear
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
  }, []);

  return (
    <div id='FAQ' className={styles.faqContainer}>
      <div className={styles.contentWrapper}>
        <div className={styles.leftSection}>
          <h1 className={styles.title}><span className={styles.titleWhite}>Preguntas</span><br /><span className={styles.titleBlue}>Frecuentes</span></h1>
          <div className={styles.subtitleWrapper}>
            <FaRegQuestionCircle className={styles.questionIcon} />
            <p className={styles.subtitle}>Resuelve tus dudas sobre Relatividad IA.</p>
          </div>
          <div className={styles.divisorLine}></div>
          <div className={styles.formSection}>
            <p className={styles.formText}>¿No encuentras tu pregunta o tienes una duda específica? <span className={styles.boldText}>Envíanos</span> un mensaje y te ayudamos.</p>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="nombre"
                placeholder="Nombre"
                value={formData.nombre}
                onChange={handleInputChange}
                className={styles.input}
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
                className={styles.input}
              />
              <input
                type="tel"
                name="celular"
                placeholder="Celular"
                value={formData.celular}
                onChange={handleInputChange}
                className={styles.input}
              />
              <textarea
                name="mensaje"
                placeholder="Mensaje"
                value={formData.mensaje}
                onChange={handleInputChange}
                className={styles.textarea}
              />
              <button type="submit" className={styles.submitButton}>Enviar</button>
            </form>
          </div>
        </div>
        <div className={styles.rightSection}>
          {questions.map((q, index) => (
            <div key={index} className={styles.questionBox} onClick={() => toggleQuestion(index)} ref={el => (questionRefs.current[index] = el)}>
              <div className={styles.questionHeader}>
                <span>{q.q}</span>
                <span className={styles.expandIcon}>{expanded[index] ? '-' : '+'}</span>
              </div>
              {expanded[index] && <div className={styles.answer}>{q.a}</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;